/* eslint-disable valid-jsdoc */
import { B2CIAM_ENUMS } from '../constants/common-enums';
import { ACCOUNT_LOCKED, DEVICE_LOCKED } from '../constants/initiator-flow-enums';

/**
 * Current B2CIAM Apis using this helper:
 * - idLookup
 * - recognize
 */
const getLockOutFlowForB2CIAMApis = response => {
  const { data: responseBody, errorObject } = response;
  const action = responseBody?.data?.actions?.[0];
  const vmg_code = responseBody?.data?.vmg_code;
  const isDeviceLock =
    action === B2CIAM_ENUMS.ABANDON ||
    responseBody?.error_details?.[0].error === B2CIAM_ENUMS.DEVICE_LOCKED ||
    errorObject?.error_details?.[0].error === B2CIAM_ENUMS.DEVICE_LOCKED ||
    vmg_code === B2CIAM_ENUMS.DEVICE_LOCKED_VMG_ERROR;
  const isAccountLock =
    action === B2CIAM_ENUMS.GUEST ||
    responseBody?.error_details?.[0].error === B2CIAM_ENUMS.ACCOUNT_LOCKED ||
    errorObject?.error_details?.[0].error === B2CIAM_ENUMS.ACCOUNT_LOCKED;
  if (isDeviceLock) {
    return DEVICE_LOCKED;
  } else if (isAccountLock) {
    return ACCOUNT_LOCKED;
  }
  return null;
};

export default getLockOutFlowForB2CIAMApis;
